<script lang="ts">
      import { LexicalParser, type EditorRoot } from '$lib/lexical/parser'
      import { getPayloadContext } from '../context/ts/PayloadGlobals.svelte'
      import LexicalElement from './parser/LexicalElement.svelte'
      import LexicalRoot from './parser/LexicalRoot.svelte'
      import { hasData } from './utils/hasData'

      $effect(() => {
            if (!root) return
            //html = Lexical.parseRoot(root as EditorRoot)
      })

      let { root = {} } = $props()

      let render = $derived.by(() => {
            if (!root || !hasData(root)) return false
            return true
      })


</script>

<span class="w-full lexical-output">
      <!--{@html html}-->
      {#if render}
            <LexicalRoot {root}></LexicalRoot>
      {/if}
</span>

<style lang="postcss">
      .lexical-output :global(*::selection) {
            background-color: var(--df-primary);
            color: [#44ffff];
      }

      .lexical-output :global(h1) {
            @apply font-[300] text-4xl mb-4;

      }

      .lexical-output :global(h2) {
            @apply font-[300] text-3xl;
      }

      .lexical-output :global(h3) {
            @apply font-[300] text-2xl;
      }

      .lexical-output :global(h4) {
            @apply font-[300] text-4xl mb-4  text-[var(--df-primary)];
      }

      .lexical-output :global(h5) {
            @apply font-[300] text-3xl  text-[var(--df-primary)];
      }

      .lexical-output :global(h6) {
            @apply font-[300] text-2xl  text-[var(--df-primary)];
      }

      .lexical-output :global(p) {
            @apply text-base my-4 leading-8 font-primary;
            color: #414141;
      }

      .lexical-output :global(.lexical-heading > span) {
            @apply font-[500];
      }

      .lexical-output :global(.left) {
            @apply text-left;
      }

      .lexical-output :global(.right) {
            @apply text-right;
      }

      .lexical-output :global(.center) {
            @apply text-center;
      }

      .lexical-output :global(.justify) {
            @apply text-justify;
      }

      .lexical-output :global(.lexical-link) {
            @apply text-[#429542] opacity-100 transition-opacity hover:opacity-30;
      }

      .lexical-output :global(.lexical-link)::after {
            background-image: url(/link.svg);
            content: '';
            background-size: 100%;
            height: 1em;
            display: inline-block;
            aspect-ratio: 1 / 1;
            background-position: center;
            vertical-align: middle;
            margin-left: 0.1em;
            margin-bottom: 0.2rem;
      }

      .lexical-output :global(.lexical-bold) {
            @apply font-bold;
      }

      .lexical-output :global(.lexical-italic) {
            @apply italic;
      }

      .lexical-output :global(.lexical-quote) {
            @apply px-[3em] italic text-xl border-l-0 py-2 my-8;
            text-wrap: pretty;
      }

      /*.lexical-output :global(.lexical-quote)::before,
      .lexical-output :global(.lexical-quote)::after {
            background-image: url(/quote.svg);
            content: '';
            background-repeat: no-repeat;
            opacity: 0.4;
            background-size: 70%;
            height: 1em;
            display: inline-block;
            aspect-ratio: 1 / 1;
            background-position: top;
            vertical-align: middle;
            margin-left: 0.1em;
      }*/

      .lexical-output :global(.lexical-strike) {
            animation: blink alternate-reverse infinite 1s ease-in-out;
      }

      .lexical-output :global(.lexical-underline) {
            @apply underline;
      }
</style>
